/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

import {APP_INITIALIZER, LOCALE_ID, NgModule} from '@angular/core';
import {LocalConfig} from 'sihw-ngx';

import {AppComponent} from './app.component';

import {SchermenModule} from '../schermen/schermen.module';
import {NgxSpinnerModule} from 'ngx-spinner';
import {NgOptimizedImage, registerLocaleData} from '@angular/common';
import localeNL from '@angular/common/locales/nl';
import {BrowserModule} from '@angular/platform-browser';
import {ApiModule} from '../services/api/api.module';
import {SihwWindowmanagerModule} from '../components/windowmanager/windowmanager.module';
import {FormsModule} from '@angular/forms';
import {ReleaseInfoComponent} from '../components/release-info/release-info.component';
import {WachtwoordComponent} from '../components/wachtwoord/wachtwoord.component';

registerLocaleData(localeNL);

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    ApiModule,
    NgxSpinnerModule, //ngx-spinner https://www.npmjs.com/package/ngx-spinner //in api (gebruik) en in app (display)
    //schermen (enorme module, maar goed)
    SchermenModule,
    SihwWindowmanagerModule,
    FormsModule,
    NgOptimizedImage,
    ReleaseInfoComponent,
    WachtwoordComponent
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'nl'},
    {provide: APP_INITIALIZER, useFactory: () => () => LocalConfig.init(), multi: true}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
